import type { SpriteAssetManifest } from '../types';

const publicAsset = (path: string): string => `${import.meta.env.BASE_URL}${path}`;

/**
 * These generated images are the primary visual path. Asset generation may replace
 * any file without changing gameplay code as long as the grid contract is preserved.
 */
export const DEFAULT_PLATFORMER_ASSET_MANIFEST: SpriteAssetManifest = {
  'mario-idle': {
    id: 'mario-idle',
    src: publicAsset('assets/sprites/platformer/mario-idle.png'),
    columns: 4,
    rows: 1,
    frameCount: 4,
  },
  'mario-run': {
    id: 'mario-run',
    src: publicAsset('assets/sprites/platformer/mario-run.png'),
    columns: 4,
    rows: 1,
    frameCount: 4,
  },
  'mario-jump': {
    id: 'mario-jump',
    src: publicAsset('assets/sprites/platformer/mario-jump.png'),
    columns: 3,
    rows: 1,
    frameCount: 3,
  },
  'mario-fall': {
    id: 'mario-fall',
    src: publicAsset('assets/sprites/platformer/mario-fall.png'),
    columns: 2,
    rows: 1,
    frameCount: 2,
  },
  'mario-death': {
    id: 'mario-death',
    src: publicAsset('assets/sprites/platformer/mario-death.png'),
    columns: 4,
    rows: 1,
    frameCount: 4,
  },
  'goomba-walk': {
    id: 'goomba-walk',
    src: publicAsset('assets/sprites/platformer/goomba-walk.png'),
    columns: 2,
    rows: 1,
    frameCount: 2,
  },
  'goomba-squashed': {
    id: 'goomba-squashed',
    src: publicAsset('assets/sprites/platformer/goomba-squashed.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  coin: {
    id: 'coin',
    src: publicAsset('assets/sprites/platformer/coin.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  tileset: {
    id: 'tileset',
    src: publicAsset('assets/sprites/platformer/tileset.png'),
    columns: 4,
    rows: 1,
    frameCount: 4,
    frameWidth: 16,
    frameHeight: 16,
  },
  cloud: {
    id: 'cloud',
    src: publicAsset('assets/sprites/platformer/cloud.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  hill: {
    id: 'hill',
    src: publicAsset('assets/sprites/platformer/hill.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  bush: {
    id: 'bush',
    src: publicAsset('assets/sprites/platformer/bush.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  castle: {
    id: 'castle',
    src: publicAsset('assets/sprites/platformer/castle.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  flagpole: {
    id: 'flagpole',
    src: publicAsset('assets/sprites/platformer/flagpole.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'sky-layer': {
    id: 'sky-layer',
    src: publicAsset('assets/maps/world-1-sky-runtime.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'far-bg-layer': {
    id: 'far-bg-layer',
    src: publicAsset('assets/maps/world-1-far-bg.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
    chromaKeyMagenta: true,
  },
  'near-bg-layer': {
    id: 'near-bg-layer',
    src: publicAsset('assets/maps/world-1-near-bg.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
    chromaKeyMagenta: true,
  },
  'ground-left': {
    id: 'ground-left',
    src: publicAsset('assets/sprites/platformer/ground-left.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'ground-middle': {
    id: 'ground-middle',
    src: publicAsset('assets/sprites/platformer/ground-middle.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'ground-right': {
    id: 'ground-right',
    src: publicAsset('assets/sprites/platformer/ground-right.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'ground-stair': {
    id: 'ground-stair',
    src: publicAsset('assets/sprites/platformer/ground-stair.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'brick-block': {
    id: 'brick-block',
    src: publicAsset('assets/sprites/platformer/brick-block.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'question-block': {
    id: 'question-block',
    src: publicAsset('assets/sprites/platformer/question-block.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  'used-block': {
    id: 'used-block',
    src: publicAsset('assets/sprites/platformer/used-block.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
  pipe: {
    id: 'pipe',
    src: publicAsset('assets/sprites/platformer/pipe.png'),
    columns: 1,
    rows: 1,
    frameCount: 1,
  },
};
